export const RIDER_REPORT_OPTIONS = [
  { id: "ride", label: "Ride issue", icon: "🚗" },
  { id: "payment", label: "Payment issue", icon: "💳" },
  { id: "driver", label: "Driver issue", icon: "👤" },
  { id: "gps", label: "GPS issue", icon: "📍" },
  { id: "bug", label: "App bug", icon: "🐛" },
  { id: "suggestion", label: "Suggestion", icon: "💡" },
  { id: "contact", label: "Contact Support", icon: "✉️" },
  { id: "emergency", label: "Emergency", icon: "🆘", emergency: true },
];

export const DRIVER_REPORT_OPTIONS = [
  { id: "rider", label: "Report Rider", icon: "👤" },
  { id: "payment", label: "Report Payment", icon: "💳" },
  { id: "gps", label: "Report GPS", icon: "📍" },
  { id: "vehicle", label: "Vehicle issue", icon: "🚗" },
  { id: "withdrawal", label: "Withdrawal issue", icon: "🏦" },
  { id: "suggestion", label: "Suggestion", icon: "💡" },
  { id: "emergency", label: "Emergency", icon: "🆘", emergency: true },
];

export const DELIVERY_REPORT_OPTIONS = [
  { id: "customer", label: "Report Customer", icon: "👤" },
  { id: "store", label: "Report Store", icon: "🏪" },
  { id: "delivery", label: "Report Delivery", icon: "📦" },
  { id: "payment", label: "Payment issue", icon: "💳" },
  { id: "gps", label: "GPS issue", icon: "📍" },
  { id: "suggestion", label: "Suggestion", icon: "💡" },
];
